//#region Imports

import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

//#endregion

//#region Service

@Injectable({
  providedIn: 'root'
})
export class CloudflareTurnstileService {
  //#region Constructor

  constructor() {
    this.tokenSubject = new BehaviorSubject<string | null>(null);
    this.token$ = this.tokenSubject.asObservable();
    this.resetSubject = new Subject<void>();
    this.reset$ = this.resetSubject.asObservable();
  }

  //#endregion

  //#region Public Properties

  public readonly reset$: Observable<void>;

  public readonly token$: Observable<string | null>;

  private readonly resetSubject: Subject<void>;

  private readonly tokenSubject: BehaviorSubject<string | null>;

  //#endregion

  //#region Public Methods

  public set(token: string): void {
    this.tokenSubject.next(token);
  }

  public clear(): void {
    this.tokenSubject.next(null);
  }

  public get(): string | null {
    return this.tokenSubject.value;
  }

  public reset(): void {
    this.clear();
    this.resetSubject.next();
  }

  public hasValidToken(): boolean {
    return !!this.tokenSubject.value;
  }

  //#endregion
}

//#endregion
